var _style, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSubBlock = function SvgSubBlock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "subBlock_svg__\\u56FE\\u5C42_1",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".subBlock_svg__st0,.subBlock_svg__st1{fill:none}.subBlock_svg__st1{stroke:#333;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:2}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 14.5h14v6H7v-6M7 3.5h14v6H7v-6",
    className: "subBlock_svg__st0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 6.5v3h14v-6H7zm0 0H3v11h4m0 0v3h14v-6H7z",
    className: "subBlock_svg__st1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 6.5H3v11h4M7 14.5h14v6H7v-6M7 3.5h14v6H7v-6",
    className: "subBlock_svg__st1"
  })));
};
export default SvgSubBlock;